import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 40\" id=\"arrow-down\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 3.75c.69 0 1.25.56 1.25 1.25v26.982l10.366-10.366a1.25 1.25 0 0 1 1.768 1.768l-12.5 12.5a1.25 1.25 0 0 1-1.768 0l-12.5-12.5a1.25 1.25 0 0 1 1.768-1.768L18.75 31.982V5c0-.69.56-1.25 1.25-1.25Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol